import $ from 'jquery'
// import 'jquery.nicescroll'
import EmblaCarousel from "embla-carousel"
//https://github.com/davidcetinkaya/embla-carousel
export default {
    init(){
        $(()=>{
            let align = 0.057291666666667
            let width = $('body').width()
            if(width > 768 && width <= 1366){
                align = 0.029282576867
            }
            let embla =  EmblaCarousel($('.section-projects > .section-container > .projects-wrap  .projects-box')[0] , {
                dragFree: true,
                loop: true,
                containScroll: "trimSnaps",
                align
            })
            // $('header > .menus').addClass('show')
            $('header > .menus > .mobile').click(() => {
                if($('header > .menus').is('.show')){
                    $('header > .menus').removeClass('show')
                }else{
                    $('header > .menus').addClass('show')
                }
                
            })
            $('header > .menus  ul li a').click(()=>{
                if($('header > .menus').is('.show')){
                    $('header > .menus').removeClass('show')
                }
            })
            let contact = $('.section-projects div.footer  .content > span:last').html()
            $('header > .menus  ul').append(`<div class="contact mobile">${contact}</div>`)


            $('.section-projects > .section-head .button').click(function(e){
                if($(this).is('.button-prev')){
                    embla.scrollPrev()
                }else{
                    embla.scrollNext()
                }
            })
        })

        $('.section-projects .projects-wrap .projects .project .info .detail').niceScroll({touchbehavior:true,cursorwidth: "0px",cursorborder:'none',grabcursorenabled: false});
    }
    
}